module.exports = __webpack_public_path__ + "static/faqBannerIcon-7dc98fa27ba7821c0e9c1a7f6cf25988.png";